import { CourseMaterial } from "./coursesLoader.ts";
import { useFetchers } from "react-router-dom";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import { OptDecision } from "../../../../common/api/decimal/methods/course.ts";

type OptInOutStatus =
  | "none"
  | "opting_in"
  | "opting_in_reload"
  | "opting_out"
  | "opting_out_reload";

export default function useMaterialOptInOutStatus(material: CourseMaterial) {
  const intl = useIntl();
  const fetchers = useFetchers();
  let fetcherStatus;
  let optInOutStatus: OptInOutStatus = "none";
  let processingDecision: OptDecision | undefined = undefined;
  const updateFetcher = fetchers.find(
    (f) =>
      f.formMethod === "PUT" &&
      f.formAction?.includes("my-courses/content-decision") &&
      Number(f.formData?.get("verbaLicenseId")) === material.verbaLicense?.id
  );
  if (updateFetcher) {
    if (updateFetcher.state !== "idle") {
      processingDecision = updateFetcher.formData?.get(
        "decision"
      ) as OptDecision;
      fetcherStatus = updateFetcher.state;
    }
  }

  if (processingDecision) {
    const isOptingOut = processingDecision === "opt_out";
    const isSubmitting = fetcherStatus === "submitting";
    if (isOptingOut) {
      optInOutStatus = isSubmitting ? "opting_out" : "opting_out_reload";
    } else {
      optInOutStatus = isSubmitting ? "opting_in" : "opting_in_reload";
    }
  }

  const messages: Record<OptInOutStatus, string> = {
    none: "",
    opting_in: intl.formatMessage({
      defaultMessage: "Opting you back into this course material",
    }),
    opting_in_reload: intl.formatMessage({
      defaultMessage: "Updating your course material access after opting in",
    }),
    opting_out: intl.formatMessage({
      defaultMessage: "Opting you out of this course material",
    }),
    opting_out_reload: intl.formatMessage({
      defaultMessage: "Updating your course material access after opting out",
    }),
  };

  const optingInOutMessage = messages[optInOutStatus];

  return useMemo(
    () => ({
      optInOutStatus,
      isOptInOutProcessing: !!optingInOutMessage.length,
      optingInOutMessage,
    }),
    [optInOutStatus, optingInOutMessage]
  );
}
